interface CSVOptions {
  filename: string;
  headers?: Record<string, string>; // Map of data keys to display headers
  dateFields?: string[]; // Fields that should be formatted as dates
}

export function downloadCSV(data: any[], options: CSVOptions) {
  try {
    const { filename, headers: headerMap, dateFields = [] } = options;
    
    // Get headers from first object or use provided header map
    const dataHeaders = Object.keys(data[0] || {});
    const headers = headerMap || dataHeaders.reduce((acc, key) => ({ ...acc, [key]: key }), {});
    
    // Convert data to CSV format
    const csvContent = [
      // Headers row
      Object.values(headers).join(','),
      // Data rows
      ...data.map(row => 
        Object.keys(headers).map(key => {
          const value = row[key];
          
          // Handle null/undefined
          if (value === null || value === undefined) return '';
          
          // Format dates
          if (dateFields.includes(key) && value) {
            return `"${new Date(value).toLocaleString()}"`;
          }
          
          // Handle objects
          if (typeof value === 'object') {
            return `"${JSON.stringify(value).replace(/"/g, '""')}"`;
          }
          
          // Handle strings with commas or quotes
          if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          
          return value;
        }).join(',')
      )
    ].join('\n');

    // Create and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    
    // Create download link
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href); // Clean up
  } catch (error) {
    console.error('Error generating CSV:', error);
    throw new Error('Failed to generate CSV file');
  }
}